export default {
    ExpenseRegular: 1,
    ExpenseInvest: 2,
    ExpenseProject: 3,
    ExpenseOther: 4,
    RevenueBudget: 5,
    RevenueBusiness: 6,
    ExpenseBusiness: 7,
    ExpenseFees: 8
};